module.exports = __webpack_public_path__ + "img/chinesecompany172.61b10cfa.png";